import { render, staticRenderFns } from "./InventoryTransactionTable.vue?vue&type=template&id=e355fa0e&scoped=true"
import script from "./InventoryTransactionTable.vue?vue&type=script&lang=ts"
export * from "./InventoryTransactionTable.vue?vue&type=script&lang=ts"
import style0 from "./InventoryTransactionTable.vue?vue&type=style&index=0&id=e355fa0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e355fa0e",
  null
  
)

export default component.exports